module.exports = __webpack_public_path__ + "img/cant-make-this-shit-up.d6cd6bd4.png";